var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: _vm.question.getItemClass(_vm.item),
      attrs: { role: "presentation" },
    },
    [
      _c("label", { class: _vm.question.getLabelClass(_vm.item) }, [
        _c("input", {
          class: _vm.question.cssClasses.itemControl,
          attrs: {
            type: "checkbox",
            name: _vm.question.name + _vm.item.id,
            required: _vm.question.hasRequiredError(),
            id: _vm.question.getItemId(_vm.item),
            disabled: !_vm.question.getItemEnabled(_vm.item),
            readonly: _vm.question.isReadOnlyAttr,
          },
          domProps: {
            checked: _vm.question.isItemSelected(_vm.item),
            value: _vm.item.value,
          },
          on: {
            input: function (e) {
              _vm.question.clickItemHandler(_vm.item, e.target.checked)
            },
          },
        }),
        _vm.question.cssClasses.materialDecorator
          ? _c("span", { class: _vm.question.cssClasses.materialDecorator }, [
              _vm.question.itemSvgIcon
                ? _c("svg", { class: _vm.question.cssClasses.itemDecorator }, [
                    _c("use", {
                      attrs: { "xlink:href": _vm.question.itemSvgIcon },
                    }),
                  ])
                : _vm._e(),
            ])
          : _vm._e(),
        !_vm.hideLabel
          ? _c(
              "span",
              { class: _vm.question.cssClasses.controlLabel },
              [_c("survey-string", { attrs: { locString: _vm.item.locText } })],
              1
            )
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }